export default __webpack_public_path__ + "static/media/icon-house.c7e43da3.svg";